module.exports = __webpack_public_path__ + "static/media/blog.afbb04f5.svg";